export const createTokenFromText = (text: string): string => {
  if (text == null) return ''

  return text
    .replace(/[^a-z0-9 ]/gi, '')
    .replace(/^[0-9]+/g, '')
    .trim()
    .replace(/ /g, '-')
    .toLowerCase()
}
